export default __webpack_public_path__ + "8890ca435bcb8db1d8982887e83f8ef3.png";